import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SuperpartnerService {
  static getAllSuperpartner = () => {
    let url = `${REACT_APP_REST_ENDPOINT}/superpartner`;
    return ApiService.getRudeRequest(url);
  };
}